<div id="invite-form" class="container">
  @if (company) {
    <div class="row">
      <div class="col-md-12 text-center">
        <h2>Invite users to {{ company.name }}.</h2>
      </div>
    </div>
  }
  <hr />
  <app-company-invite-form></app-company-invite-form>
</div>
